import React from 'react';
import { Row, Col, Container, Card, Image } from 'react-bootstrap';

function Projects(){
    return(
    <React.Fragment>
        <Container id="Projects" fluid className="dark container">
            <br></br>        
            <h1 className="text-center">Projects</h1>
            <hr/>
            <p>Over past few months, i have worked on various projects including this portfolio website as well.
                I have developed a timer-app, box-game, hostel booking website and inventory-admin application.
                I also developed a android application to store student's database with 3 other members as my college mini-project.
                I am currently working on a web-app called "Centralized Hospital Bed Management System" as my Final Year Project.
            </p>
            <br></br>
            <Row>
                <Col xs={12} md={4} className="justify-content-center">
                    <Card bg="primary" text="light" style={{ width: '18rem' }} className="mb-2">
                        <Card.Header>Student Database App</Card.Header>
                        <Card.Body>
                        <Card.Title>Android Application </Card.Title>
                        <Card.Text>
                             This app provides the facilty of storing students data such as marks, attendance, etc. 
                             Teachers can modify database and students can see their data.
                             Different login pages for student and teachers.
                        </Card.Text>
                        </Card.Body>
                     </Card>
                </Col>
                <Col xs={12} md={4} className="justify-content-center">
                    <Card bg="success" text="light" style={{ width: '18rem' }} className="mb-2">
                        <Card.Header>Hostel Booking Site</Card.Header>
                        <Card.Body>
                        <Card.Title>Web Application </Card.Title>
                        <Card.Text>
                            A simple website where students can find cheap accomodations.
                            All you need to do is just sign-up into the hostlers website and search for your city.
                            You'll get a list of cheap option to select.
                        </Card.Text>
                        </Card.Body>
                     </Card>
                </Col>     
                <Col xs={12} md={4} className="justify-content-center">
                    <Card bg="dark" text="light" style={{ width: '18rem' }} className="mb-2">
                        <Card.Header>SaurabhMishra.netlify</Card.Header>
                        <Card.Body>
                        <Card.Title>Portfolio Website </Card.Title>
                        <Card.Text>
                            A single-page react portfolio website to showcase my skills of website development
                            as well as give information about myself.
                            You can see about my hobbies, education details, certificates etc.
                        </Card.Text>
                        </Card.Body>
                     </Card>
                </Col>
            </Row>
            <br></br>
            {/*
                <Row>
                <Col xs={12} md={4} className="justify-content-center">
                    <Card bg="secondary" text="light" style={{ width: '18rem' }} className="mb-2">
                        <Card.Header>Header</Card.Header>
                        <Card.Body>
                        <Card.Title>Card Title </Card.Title>
                        <Card.Text>
                            Some quick example text to build on the card title and make up the bulk
                            of the card's content.
                        </Card.Text>
                        </Card.Body>
                     </Card>
                </Col>
                <Col xs={12} md={4} className="justify-content-center">
                    <Card bg="warning" text="light" style={{ width: '18rem' }} className="mb-2">
                        <Card.Header>Header</Card.Header>
                        <Card.Body>
                        <Card.Title>Card Title </Card.Title>
                        <Card.Text>
                            Some quick example text to build on the card title and make up the bulk
                            of the card's content.
                        </Card.Text>
                        </Card.Body>
                     </Card>
                </Col>     
                <Col xs={12} md={4} className="justify-content-center">
                    <Card bg="info" text="light" style={{ width: '18rem' }} className="mb-2">
                        <Card.Header>Header</Card.Header>
                        <Card.Body>
                        <Card.Title>Card Title </Card.Title>
                        <Card.Text>
                            Some quick example text to build on the card title and make up the bulk
                            of the card's content.
                        </Card.Text>
                        </Card.Body>
                     </Card>
                </Col>
            </Row>
            */}

            <br></br>
            
        </Container>
    </React.Fragment>
    );

}

export default Projects;